<template>
    <base-box background-color="grey">
        <div slot="content">
            <g-media-object>
                <g-level class="g-mb-3">
                    <g-typography tag="span" font-weight="semibold" :value="label" />
                </g-level>
                <g-level v-for="(text, index) in allText" :key="index + text" class="g-mb-2">
                    <g-level-item>
                        <g-typography tag="span" :value="text" class="g-break-all" />
                    </g-level-item>
                    <g-level-item slot="right">
                        <g-copy-button shape="circle" icon="copy" :minimalist="true" :copy-text="text" theme="live" />
                    </g-level-item>
                </g-level>
            </g-media-object>
        </div>
    </base-box>
</template>

<script>
    import {pluralize} from '../../../../helpers/string-helpers';

    export default {
        name:  'LinkCodeBox',
        props: {
            affiliateLinks: {
                type:    Array,
                default: () => [],
            },
            discountCodes: {
                type:    Array,
                default: () => [],
            },
        },
        computed: {
            label() {
                return `Your ${this.slug}: `;
            },
            slug() {
                if (this.affiliateLinks.length > 0) {
                    return pluralize(this.affiliateLinks.length, 'Link');
                }
                if (this.discountCodes.length > 0) {
                    return pluralize(this.discountCodes.length, 'Discount Code');
                }
                return null;
            },
            allText() {
                if (this.affiliateLinks.length > 0) {
                    return this.affiliateLinks.map(link => link.short_url);
                }
                if (this.discountCodes.length > 0) {
                    return this.discountCodes.map(code => code.code);
                }
                return [];
            },
        },
        created() {
            if (this.affiliateLinks.length > 0 && this.discountCodes.length > 0) {
                throw new Error('Should only provide affiliateLinks OR discountCodes, not both');
            }
        },
    };
</script>
